// extracted by mini-css-extract-plugin
module.exports = {"marketContainer":"_cfe65d4","eventStatusContainer":"_9668243","marketName":"_6474408"};